import { connect } from 'react-redux';

// @ts-expect-error missing types
import { appendFormFieldGroup } from 'FormsUI/actions/FormDragDrop';
// @ts-expect-error missing types
import DeadSpaceDropZone from 'FormsUI/components/editor/form/dropZone/DeadSpaceDropZone';
const mapStateToProps = () => {};
const mapDispatchToProps = {
  appendFormFieldGroup
};
export default connect(mapStateToProps, mapDispatchToProps)(DeadSpaceDropZone);